module.exports = __webpack_public_path__ + "img/smoke.4f098d6b.svg";